import i18n from '../i18n';

export default class CarrierJapanType {
  public static readonly NONE = new CarrierJapanType('', '-');
  public static readonly YAMATO = new CarrierJapanType('ヤマト', 'ヤマト');
  public static readonly SAGAWA = new CarrierJapanType('佐川', '佐川');
  public static readonly NIHON = new CarrierJapanType('日本郵便', '日本郵便');


  public static values(): any {
    return [
      { value: this.NONE.value, text: i18n.t(this.NONE.text) },
      { value: this.YAMATO.value, text: i18n.t(this.YAMATO.text) },
      { value: this.SAGAWA.value, text: i18n.t(this.SAGAWA.text) },
      { value: this.NIHON.value, text: i18n.t(this.NIHON.text) },
    ];
  }

  public static filterValues(): any {
    return [
      { value: this.NONE.value, text: i18n.t(this.NONE.text) },
      { value: this.YAMATO.value, text: i18n.t(this.YAMATO.text) },
      { value: this.SAGAWA.value, text: i18n.t(this.SAGAWA.text) },
      { value: this.NIHON.value, text: i18n.t(this.NIHON.text) },
    ];
  }

  public static valueOf(value: string): CarrierJapanType {
    for (const v of this.values()) {
      if (v.value === value) {
        return v;
      }
    }
    return CarrierJapanType.NONE;
  }

  // public static getValue(value: string): string {
  //   if(value === '1'){
  //     return '通常';
  //   } else{
  //     return 'DHL';
  //   }
  // }

  private constructor(public readonly value: string, public readonly text: string) {}
  // public getValue(): string { return this.value; }
  public getText(): string { return this.text; }
  public equals(other: CarrierJapanType): boolean { return (this.text === other.text) ? true : false; }
  public toString(): string { return `${this.text}(${this.text})`; }
}
